import React from "react";
import { RowColors, RowOptions } from "../TableSection/TableSection";
import { CardTable } from "../CardTable/CardTable";
import LecturesLogo from "../../assets/headings/lectures.svg"
import { SectionProps } from "../../App";
import { hideRowLinks, isReleased } from "../../data/releaseSchedule";
import { lectureAnchor } from "../../data/lectureAnchors";
import { getCourseContent } from "../../data/courseContent";

export class Lectures extends React.Component<SectionProps> {

  render() {
    const { lecturesTable } = getCourseContent();
    const modifiedRows: RowOptions[] = lecturesTable.rows.map((row) => {
      if (!isReleased(row)) {
        return {
          ...hideRowLinks(row),
          backgroundColor: RowColors.LOCKED,
          locked: true,
        };
      }
      return row;
    });
    return (
      <section
        id="lectures"
        className={`anchor lectures ${this.props.static ? "static" : ""}`}
      >
        <div className="section-heading">
          <img
            className="lectures-logo logo"
            src={LecturesLogo}
            alt="lectures text"
          />
        </div>
        <CardTable
          compact
          header={lecturesTable.header}
          rows={modifiedRows}
          titleIndex={1}
          resourceStartIndex={2}
          idFor={(title) => lectureAnchor(title)}
        />
      </section>
    );
  }
}
